import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "StudyResc",
    isNumber: true,
    isSum: true,
  },
];

export const DateToCheckItemAnalysis = {
  label: "篩檢年度",
  key: "DateToCheckItemAnalysis",
  path: "ElderlyHealthCheckup/DateToCheckItemAnalysis",
  api: "TCS_V_OldStudyList01V",
  render: (options) => (
    <Diagram.ElderlyHealthCheckup.DateToCheckItemAnalysis {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "StudyYear",
      field: "StudyYear",
      header: "",
      isSkip: true,
    },
  ],
  levelColumns,
  columns: [],
};
